<div class="row page-header">
    <div class="col-12">
        <h1>Competitor Bids <small>View jobs bid on by a selected competitor</small></h1>
    </div>
</div>
@if (!isInitialLoading) {
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <wj-combo-box
                            name="selectedCompetitor"
                            [itemsSource]="competitorMap"
                            (selectedIndexChanged)="onCompetitorChange()"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [isRequired]="false"
                            [placeholder]="'Select a Competitor'"
                            [(selectedIndex)]="selectedCompetitor"
                        >
                        </wj-combo-box>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Competitor Bids'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        #mainGrid
                        appAutoSize
                        [padding]="73"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="250"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Bid Type'"
                            [binding]="'bidType'"
                            [width]="180"
                            [dataMap]="jobTypeMap"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Heavy Bid #'"
                            [binding]="'heavyBidNum'"
                            [width]="100"
                            [format]="'D'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Bid Date'"
                            [binding]="'bidDate'"
                            [width]="130"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Bid Amount'"
                            [binding]="'bidAmount'"
                            [width]="120"
                            [format]="'C0'"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Rank'"
                            [binding]="'rank'"
                            [width]="80"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Won'"
                            [binding]="'won'"
                            [width]="70"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'# Bidders'"
                            [binding]="'numBidders'"
                            [width]="90"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Low'"
                            [binding]="'low'"
                            [width]="120"
                            [format]="'C0'"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'High'"
                            [binding]="'high'"
                            [width]="120"
                            [format]="'C0'"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'VanCon'"
                            [binding]="'vanCon'"
                            [width]="120"
                            [format]="'C0'"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Lower Than VanCon'"
                            [binding]="'lowerThanVanCon'"
                            [width]="130"
                            [dataType]="'Boolean'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>

                    <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
}
